import React, { useEffect, useState } from "react";
import CommandJson from "./CommandJson.json";
import DeleteIcon from "@material-ui/icons/Delete";
import styles from "../Events.module.css";
import DropDownMenu from "../ReusableComp/DropDownMenu";
import Input from "../ReusableComp/Input";
import ToggleBtn from "../../../ReusableComponents/ToggleBtn/ToggleBtn";
import { BlueButton } from "../../../ReusableComponents/GetButtons/GetButtons";
import "../../../ReusableComponents/GetButtons/getButton.css"
import { makeStyles } from "@material-ui/core/styles";
import remove from "../../../Icons/Event/remove.png";
import downarrow_svg   from "../../../Icons/Event/downarrow_svg.svg";
import uparrow_svg from "../../../Icons/Event/uparrow_svg.svg";
import { useTranslation } from "react-i18next";
import { GetStateFromData } from "../../../components/CustomHooks/CustomHooks";
import ProcessMappingPopup from "../Processmapping/ProcessMapping.jsx";
import secureLocalStorage from "react-secure-storage";
import { recursiveJsonReader1 } from '../../../components/IFormDesignerLayout/ApplicationAPI/applicationApi.js';
import { getFormJsonFromStore, encrypt, decryptMessage } from '../../../components/IFormDesignerLayout/IFormDesignerLogic.jsx';
import secureSessionStorage from "../../../utils/secureSessionStorage.js";

const useStyles = makeStyles({
  table: {
    width: "94%",
    "& table": {
      margin: "10px",
      border: "1px solid #C4C4C4",
    },
    "& td": {
      fontSize: "12px",
      border: "1px solid #C4C4C4",
      padding: "10px !important",
    },
    "& th": {
      fontSize: "12px",
      border: "1px solid #C4C4C4",
      padding: "10px !important",
    },
  },
  getPicklistDataSection: {
    width: "100%",
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    background: "#F8F8F8",
    "& .MuiInputBase-root": {
      backgroundColor: "#FFFFFF",
      width: "calc(100% - 1px) !important",
    },
  },
});

const Command = (props) => {
  const translationStyles1 =
    window?.psh_configs?.selectedLanguage === "ar" ||
    window?.psh_configs?.selectedLanguage === "ar-SA";
  const classes = useStyles();
  const { t } = useTranslation();
  const [command, setCommand] = React.useState(
    props.defaultState || {
      commandName: "",
      commandParams: {},
    }
  );
  const contexts = GetStateFromData();
  const gridContexts = GetStateFromData(undefined, "data2");
  const { advanceListviewStateJson } = gridContexts.gridStates;
  const {
    updateJson,
    changeSectionLayout,
    formState2,
    deleteControl,
    customControlIdList,
    setCustomControlIdList,
    allPages,
    allSubForms,
    isPortal,
    subFormStateJson,
    openCanvasForSubform,
    currentListviewForSubform,
    activeApplication
  } = contexts.contexts;
  const { updatedComponentInFormState, removeAndUpdateComponentInFormState } =
    updateJson;
  const arr = isPortal
    ? CommandJson[props.elemtype]
    : props.elemtype === "button"
    ? CommandJson["button1"]
    : [];
  const options = [];

  const [allPagesArr, setAllPagesArr] = useState(["Select"]);
  const [authTypeArr, setAuthTypeArr] = useState(["NewgenOne"]);
  const [userNameArr, setUserNameArr] = useState(["Select"]);
  const [tableColumnsNameArr, settableColumnsNameArr] = useState(["Select"]);
  const [passwordArr, setPasswordArr] = useState(["Select"]);
  const [tableYesNoArr, setTableYesNoArr] = useState(["Select", "Yes", "No"]);
  const [captchaArr, setCaptchaArr] = useState(["none"]);
  const [buttonArr, setButtonArr] = useState(["none"]);
  const [tileArr, setTileArr] = useState(["Select"]);

  const [parametersTile_arr, setParametersTile_arr] = useState(
    (props.defaultState && props.defaultState.ParametersArray) || []
  );

  const [decryptedQuery, setDecryptedQuery] = useState("");

  useEffect(() => {
    if (command?.Name === "GetPicklistData" && command?.Parameters?.Query) {
      decryptMessage(command.Parameters.Query).then((res) => {
        setDecryptedQuery(res || "");
      });
    }
  }, [command?.Name]);

  const [formNames, setFormNames] = useState(["Select"]);

  useEffect(() => {
    if (allPages) {
      let get_pages = [];
      allPages.forEach((page) => {
        if (page.formName) {
          get_pages.push(page?.formName);
        }
      });
      setFormNames((prev) => [...prev, ...get_pages]);
    }
  }, [allPages]);

  const [tableContentData, setTableContentData] = useState(new Map());

  useEffect(() => {
    let tableContent = new Map();
    recursiveJsonForTable(formState2, tableContent);
    setTableContentData(tableContent);

    var columnNames = ["Select"];

    if (tableContent.size > 0) {
      if (
        tableContent.get(
          props.defaultState?.Parameters?.TransactionSelectionControl
        )?.columnList
      ) {
        Object.values(
          tableContent.get(
            props.defaultState?.Parameters?.TransactionSelectionControl
          )?.columnList
        ).map((content1) => {
          columnNames.push(content1?.style?.ColumnName);
        });
      }
      settableColumnsNameArr(columnNames);
    }
  }, []);

  const gridIds = ["Select"];

  function recursiveJsonForTable(jsonData, tableContent) {
    if (Array.isArray(jsonData)) {
      jsonData.forEach((item, index) => {
        if (item?.controlName === "table") {
          tableContent.set(item.id, item);
          gridIds.push(item.id);
        }
        if (Object.keys(item).includes("children")) {
          recursiveJsonForTable(item, tableContent);
        }
      });
    } else {
      recursiveJsonForTable(jsonData["children"], tableContent);
    }
  }
  const [allGridIds, setAllGridIds] = useState(gridIds);

  const findObjectByElemType = (obj, elemtype, setVariable, variable) => {
    const children = obj.children;

    if (children !== undefined) {
      if (children.length > 0) {
        children.map((child) => {
          if (child.elem_type === elemtype || child.controlName === elemtype) {
            setVariable((prev) => {
              if (prev.includes(child.id)) {
                return [...prev];
              } else {
                return [...prev, child.id];
              }
            });
            findObjectByElemType(child, elemtype, setVariable, variable);
          } else {
            findObjectByElemType(child, elemtype, setVariable, variable);
          }
        });
      }
    }
    return false;
  };

  const findObjectByElemTypeTile = (obj, elemtype, setVariable, variable) => {
    const children = obj.children;
    if (children !== undefined) {
      if (children.length > 0) {
        children.map((child) => {
          if (child.elem_type === elemtype) {
            child.tileContents.map((tile) => {
              if (
                tile.elem_type === "CustomControl" ||
                tile.controlName === "tile"
              ) {
                setVariable((prev) => {
                  if (prev.includes(tile.id)) {
                    return [...prev];
                  } else {
                    return [...prev, tile.id];
                  }
                });
              }
            });

            findObjectByElemTypeTile(child, elemtype, setVariable, variable);
          } else {
            findObjectByElemTypeTile(child, elemtype, setVariable, variable);
          }
        });
      }
    }
    return false;
  };

  const addToTileParameters = (params) => {
    setParametersTile_arr((prev) => {
      return [...prev, { ...params }];
    });

    let temp = command;
    temp["ParametersArray"] = parametersTile_arr;

    if (temp["ParametersArray"] !== undefined) {
      temp["ParametersArray"].push(params);
    }
    setCommand(temp);
  };
  const deleteTileParameters = (count) => {
    let updatedList = parametersTile_arr.filter(
      (item, index) => index !== count
    );
    setParametersTile_arr(updatedList);
    let temp = command;
    temp["ParametersArray"] = updatedList;
    setCommand(temp);
  };

  useEffect(() => {
    if (formState2) {      
      findObjectByElemType(formState2, "textbox", setPasswordArr, passwordArr);
      findObjectByElemType(formState2, "captcha", setCaptchaArr, captchaArr);
      findObjectByElemType(formState2, "button", setButtonArr, buttonArr);

      if (openCanvasForSubform === "subform") {
        findObjectByElemType(subFormStateJson, "textbox", setUserNameArr, userNameArr);
        findObjectByElemTypeTile(subFormStateJson, "tile", setTileArr, tileArr);
      }
      else if(openCanvasForSubform==="showDataAdditonSection"){
        findObjectByElemType(currentListviewForSubform?.listviewFrameLayoutJson, "textbox", setUserNameArr, userNameArr);
        findObjectByElemTypeTile(currentListviewForSubform?.listviewFrameLayoutJson, "tile", setTileArr, tileArr);
      }
      else if(openCanvasForSubform === "advanceListviewFromScratch"){        
        findObjectByElemType(advanceListviewStateJson, "textbox", setUserNameArr, userNameArr);
        findObjectByElemTypeTile(advanceListviewStateJson, "tile", setTileArr, tileArr);
      }
      else{
        findObjectByElemType(formState2, "textbox", setUserNameArr, userNameArr);
        findObjectByElemTypeTile(formState2, "tile", setTileArr, tileArr);
      }
      
      // }
    }
  }, []);

  useEffect(() => {
    if (allPages) {
      allPages.map((page) => {
        setAllPagesArr((prev) => [...prev, page.formName]);
      });
    }
  }, [allPages]);

  arr &&
    arr.map((item) => {
      options.push(item.label);
    });

  const [commandParams, setCommandParams] = useState(
    {
      ...{
        RouteCriteria: {
          FormName: "",
          AuthenticationType: "",
          UserName: "",
          Password: "",
          CaptchaEnabled: "",
          CaptchaControl: "",
        },
        OpenTransaction: {
          NextFormName: "",
          TransactionSelectionControl: "",
          TransactionColumnName: "",
          MDMTable: "",
          ISWidget: "",
          DynamicJourney: "",
          RouteJourneyColumnName: "",
          NavigationFormColumnName: "",
        },
        CreateTransaction: {
          FormName: "",
        },
        RouteJourney: {
          TileName: "",
          FormName: "",
          DecisionField: "",
        },
        ValidateOTP: {
          FormName: "",
          OTPField: "",
        },
      },
      [props?.defaultState?.Name]: {
        ...props?.defaultState?.Parameters,
      },
    } || {
      RouteCriteria: {
        FormName: "",
        AuthenticationType: "",
        UserName: "",
        Password: "",
        CaptchaEnabled: "",
        CaptchaControl: "",
      },
      RouteJourney: {
        TileName: "",
        FormName: "",
        DecisionField: "",
      },
      ValidateOTP: {
        FormName: "",
        OTPField: "",
      },
    }
  );

  const [selectedApplication, setSelectedApplication] = useState(activeApplication);
  const [processMapping_Popup, setProcessMapping_Popup] = useState("closed");


  const [mapProcessArray, setMapProcessArray] = useState({});

  const commandMapping = {
    RouteCriteria: [
      { label: "FormName", value: allPagesArr, type: "dropdown" },
      { label: "AuthenticationType", value: authTypeArr, type: "dropdown" },
      { label: "UserName", value: userNameArr, type: "dropdown" },
      { label: "Password", value: passwordArr, type: "dropdown" },
      { label: "CaptchaEnabled", value: [], type: "checkbox" },
      { label: "CaptchaControl", value: captchaArr, type: "dropdown" },
    ],
    OpenTransaction: [
      { label: "NextFormName", value: formNames, type: "dropdown" },
      {
        label: "TransactionSelectionControl",
        value: allGridIds,
        type: "dropdown",
      },
      {
        label: "TransactionColumnName",
        value: tableColumnsNameArr,
        type: "dropdown",
      },
      { label: "MDMTable", value: tableYesNoArr, type: "dropdown" },
      { label: "ISWidget", value: tableYesNoArr, type: "dropdown" },
      { label: "DynamicJourney", value: [], type: "checkbox" },
      {
        label: "RouteJourneyColumnName",
        value: tableColumnsNameArr,
        type: "dropdown",
      },
      {
        label: "NavigationFormColumnName",
        value: tableColumnsNameArr,
        type: "dropdown",
      },
    ],
    CreateTransaction: [
      { label: "FormName", value: formNames, type: "dropdown" },
    ],
    RouteJourney: [
      { label: "TileName", value: tileArr, type: "dropdown" },
      { label: "FormName", value: allPagesArr, type: "dropdown" },
      { label: "DecisionField", value: userNameArr, type: "dropdown" },
    ],
    ValidateOTP: [
      { label: "FormName", value: allPagesArr, type: "dropdown" },
      { label: "OTPField", value: userNameArr, type: "dropdown" },
    ],
  };

  const commandMappingTile = {
    RouteJourney: [
      { label: "TileName", value: tileArr, type: "dropdown" },
      { label: "FormName", value: allPagesArr, type: "dropdown" },
      { label: "DecisionField", value: userNameArr, type: "dropdown" },
      { label: "Add", value: addToTileParameters, type: "button" },
    ],
  };

  const handleCommand = (x) => {
    let temp = {};
    temp.Name = x;
    temp["Parameters"] = commandParams.x;
    setCommand(temp);
  };

  const handleParameters = (e, label) => {
    const x = e?.target?.value || e;
    if (
      command.Name === "OpenTransaction" &&
      label === "TransactionSelectionControl"
    ) {
      var columnNames = ["Select"];

      if (tableContentData.size > 0) {
        if (tableContentData.get(x).columnList) {
          Object.values(tableContentData.get(x).columnList).map((content1) => {
            columnNames.push(content1.style.ColumnName);
          });
        }
      }
      settableColumnsNameArr(columnNames);
    }

    setCommandParams((prev) => {
      prev[command.Name][label] = x;
      return { ...prev };
    });

    const params = commandParams;
    params[command.Name][label] = x;

    let temp = {};
    temp.Name = command.Name;
    temp["Parameters"] = params[command.Name];
    setCommand(temp);
  };

  const launchpadKey =
    secureSessionStorage.getItem("Authorization") ||
    JSON.parse(secureLocalStorage.getItem("launchpadKey"))?.token;

  var jwtToken = launchpadKey || undefined;

  const [mapProcessVariable_Popup, setMapProcessVariable_Popup] =
    useState("closed");
  const [selectedMapProcess, setSelectedMapProcess] = useState({});
  const [selectedMapQueue, setSelectedMapQueue] = useState({});

  const handleInput = (x, event) => {
    let temp = command;
    if (temp.Parameters === undefined) {
      temp.Parameters = {};
    }
    temp.Parameters[event] = x;
    setCommand(temp);
  };

  const handleInputEncrypt = async (x, event) => {
    let temp = { ...command };
    if (temp.Parameters === undefined) {
      temp.Parameters = {};
    }
    temp.Parameters[event] = await encrypt(x);
    setDecryptedQuery(x);
    setCommand(temp);
  };

  var control_json= {};

  function set_control_json(json){
      // control_json = json;
      const formJson = getFormJsonFromStore();
      const control_json_var = recursiveJsonReader1(formJson, props?.control_json?.id);
      if(control_json_var){
        control_json = control_json_var;
      }
  }

  set_control_json();

  // var doneButtonsavefunctionality ;

  function addRoutingClbk( event, submitApplication ){
    if(event){
      console.log(event);
      const pagename = event?.target?.value;
      let controlJson_copy= JSON.parse( JSON.stringify( props.control_json ) );
      controlJson_copy.routeto = pagename;
      updatedComponentInFormState( controlJson_copy.id , controlJson_copy );
      set_control_json(controlJson_copy);
    }
    // doneButtonsavefunctionality = submitApplication;
    props.doneButtoncallback( submitApplication );
  }

  useEffect(() => {
    if(document.querySelector("#processMappingPopup_events_if") && allPagesArr.length>1 ){
      
      var props = {
        Module: "INTERFACEDESIGNER",
        Component: "ProcessMapping",
        Component_mf: "ProcessMapping_mf",
        InFrame: false,
        ContainerId: "processMappingPopup_events_if",
        Callback: addRoutingClbk || "appDesignerCallback",
        passedData: {
          activeApplication:activeApplication,
          pagesList: allPagesArr,
          control_json: control_json
        },
      };
    
      // if (window && window?.loadMicroFrontend) {
      //   window.loadMicroFrontend(props);
      // }

      window?.renderProcessMapping("processMappingPopup_events_if", props);
    }
  }, [command, allPagesArr]);

  useEffect(() => {
    if (props.updateHandler) {
      props.updateHandler("Command", command);
    }
  }, [command]);

  useEffect(() => {
    props.updateHandler("Command", command);
  }, [commandParams, parametersTile_arr]);

  return (
    <div className={styles.tableclass}>
      <div className={styles.eventheader}>
        <span>{t("Command")}</span>
        <span>
          <DeleteIcon
            onClick={() => {
              props.handleDelete(props.name);
            }}
          ></DeleteIcon>

          {
            props?.openedAccordian === props?.name
            ?
            <img
              src={uparrow_svg}
              onClick={() => props.setopenedAccordian("")}
              style={{
                width:"24px",
                height :"24px",
                margin:"0px 0 0 8px" 
              }}
            />
            :
            <img
              src={downarrow_svg}
              onClick={() => props.setopenedAccordian(props?.name) }
              style={{
                width:"24px", 
                height :"24px",
                margin:"0px 0 0 8px" 
              }}
            />
          }

        </span>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          flexDirection: "column",
          width: "100%",
        }}
      >
        <div
          className={styles.labelintable}
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <span
            style={
              translationStyles1
                ? { margin: "0 0 0 36px" }
                : { margin: "0 36px 0 0" }
            }
          >
            {t("Choose Command")}
          </span>

          <DropDownMenu
            width={300}
            options={options}
            command={command.Name || command.commandName}
            handleCommand={handleCommand}
          ></DropDownMenu>
        </div>

        {command.Name === "NGLaunchURL" ? (
          <div
            style={{
              width: "fit-content",
              display: "flex",
              alignItems: "flex-end",
              flexDirection: "column",
            }}
          >
            <div className={styles.labelintable}>
              {t("Url")}
              <Input
                aria-label={"Command URL"}
                width={170}
                name={"url"}
                handleInput1={handleInput}
                state={command?.Parameters?.url}
              ></Input>
            </div>
            <div className={styles.labelintable}>
              {t("WindowName")}
              <Input
                aria-label={"Window Name"}
                width={170}
                name={"windowName"}
                handleInput1={handleInput}
                state={command?.Parameters?.windowName}
              ></Input>
            </div>
            <div className={styles.labelintable}>
              {t("WindowDecoration")}
              <Input
                aria-label={"Window Decoration"}
                width={170}
                name={"windowDecoration"}
                handleInput1={handleInput}
                state={command?.Parameters?.windowDecoration}
              ></Input>
            </div>
          </div>
        ) : (
          ""
        )}

        {command.Name === "GetPicklistData" ? (
          <div className={`${classes.getPicklistDataSection} getPicklistData-section`} id="getPicklistData-section">
            <div className={styles.labelintable}>
              <div style={{ margin: "0 0 5px", font: "normal normal 100 12px/18px Open Sans", color: "#202020" }}>
                {t("Query")}<span style={{ color: "#C32525" }}>*</span>
              </div>
                <Input
                  aria-label={"Query"}
                  width={300}
                  name={"Query"}
                  handleInput1={handleInputEncrypt}
                  state={decryptedQuery}
                  inputClassName="getPicklistData-input"
                ></Input>
            </div>
            <div className={styles.labelintable}>
              <div style={{ margin: "0 0 5px", font: "normal normal 100 12px/18px Open Sans", color: "#202020" }}>
                {t("BatchSize")}
              </div>
                <Input
                  aria-label={"Batch Size"}
                  width={300}
                  name={"BatchSize"}
                  handleInput1={handleInput}
                  state={command?.Parameters?.BatchSize}
                  inputClassName="getPicklistData-input"
                ></Input>
            </div>
            <div className={styles.labelintable}>
              <div style={{ margin: "0 0 5px", font: "normal normal 100 12px/18px Open Sans", color: "#202020" }}>
                {t("PopupTitle")}
              </div>
                <Input
                  aria-label={"Popup Title"}
                  width={300}
                  name={"PopupTitle"}
                  handleInput1={handleInput}
                  state={command?.Parameters?.PopupTitle}
                  inputClassName="getPicklistData-input"
                ></Input>
            </div>
            <div className={styles.labelintable} style={{ justifyContent: "flex-start" }}>
              <div style={{ margin: "0 0 5px", font: "normal normal 100 12px/18px Open Sans", color: "#202020" }}>
                {t("EnableCaching")}
              </div>
              <ToggleBtn
                toggleState={command?.Parameters?.EnableCaching}
                handleToggle={(e, field) => {
                  const val = command?.Parameters?.EnableCaching === "true" ? "false" : "true";
                  let temp = { ...command };
                  if (!temp.Parameters) temp.Parameters = {};
                  temp.Parameters[field] = val;
                  setCommand(temp);
                }}
                field={"EnableCaching"}
              />
            </div>
          </div>
        ) : (
          ""
        )}

{command.Name === "CreateWorkitem" && (
          isPortal ? (
        <div style={{width : "100%"}}>
          {/* <div style={{display: "flex", height :"36px", border:"1px solid #C4C4C4", }}>
            <p style={{margin : "0 18px"}} >Forward mapping</p>
            <p style={{margin : "0 18px"}} >Reverse mapping</p>
          </div> */}

          <div style={{ border:"0px solid #C4C4C4", height :"auto", minHeight: "300px", position:"relative" }}>
              {/* <ProcessMappingPopup
                launchpadKey={launchpadKey}
                jwtToken={jwtToken}
                // setAlertData2={setAlertData2}
                setProcessMapping_Popup={setProcessMapping_Popup}
                setMapProcessVariable_Popup={setMapProcessVariable_Popup}
                setNewApplication={setSelectedApplication}
                newApplication={selectedApplication || activeApplication}
                setSelectedMapProcess={setSelectedMapProcess}
                setSelectedMapQueue={setSelectedMapQueue}
                mapProcessArray={mapProcessArray}
                setMapProcessArray={setMapProcessArray}
              /> */}
              <div id="processMappingPopup_events_if" style={{minHeight:"300px" , background :"#f8f8f8"}}>

              </div>

              {/* <div>
                {<span> {t("Route Journey")} </span>}
                <div>
                  <select>
                    <option> "Select"</option>
                    {allPagesArr?.map(page=>{
                      return(
                      <>
                        <option>{page}</option>
                      </>
                      )
                    })}  
                  </select>
                </div>
              </div> */}
              
              
          </div>
        </div>
        )
        :
          ( 
            <>
              <div style={{
                    padding: "5px 12px",
                    display: "flex",
                    alignSelf: "center"
              }}>
                Create workitem is not available here
              </div>
            </>
          )
        )
        }

        <div
          style={
            props.elemtype === "tile"
              ? {
                  width: "100%",
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 1fr 6em",
                }
              : {
                  width: "100%",
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                }
          }
        >
          {props.elemtype !== "tile" &&
            commandMapping?.[command.Name]?.map((item) => {
              return (
                <div
                  className={styles.labelintable}
                  style={
                    item.type === "checkbox"
                      ? { justifyContent: "flex-start", background: "#F8F8F8" }
                      : { background: "#F8F8F8" }
                  }
                >
                  {((item.label !== "CaptchaControl" &&
                    item.label !== "NavigationFormColumnName" &&
                    item.label !== "RouteJourneyColumnName") ||
                    (item.label === "CaptchaControl" &&
                      commandParams?.[command.Name]?.["CaptchaEnabled"] ===
                        "true") ||
                    (item.label === "NavigationFormColumnName" &&
                      commandParams?.[command.Name]?.["DynamicJourney"] ===
                        "true") ||
                    (item.label === "RouteJourneyColumnName" &&
                      commandParams?.[command.Name]?.["DynamicJourney"] ===
                        "true")) && (
                    <div
                      style={{
                        margin: "0 0 5px",
                        font: "normal normal 100 12px/18px Open Sans",
                        color: "#202020",
                      }}
                    >
                      {" "}
                      {t(`${item.label}`)}
                      {item.label !== "CaptchaControl" &&
                        item.label !== "CaptchaEnabled" &&
                        item.label !== "TileName" && (
                          <span style={{ color: "#C32525" }}>*</span>
                        )}{" "}
                    </div>
                  )}

                  {((item.type === "dropdown" &&
                    item.label !== "CaptchaControl" &&
                    item.label !== "NavigationFormColumnName" &&
                    item.label !== "RouteJourneyColumnName") ||
                    (item.type === "dropdown" &&
                      item.label === "CaptchaControl" &&
                      commandParams?.[command.Name]?.["CaptchaEnabled"] ===
                        "true") ||
                    (item.type === "dropdown" &&
                      item.label === "NavigationFormColumnName" &&
                      commandParams?.[command.Name]?.["DynamicJourney"] ===
                        "true") ||
                    (item.type === "dropdown" &&
                      item.label === "RouteJourneyColumnName" &&
                      commandParams?.[command.Name]?.["DynamicJourney"] ===
                        "true")) && (
                    <DropDownMenu
                      width={300}
                      options={item.value}
                      // command={command.commandName}commandParams
                      command={command?.["Parameters"]?.[item.label]}
                      handleCommand={handleParameters}
                      label={item.label}
                    ></DropDownMenu>
                  )}
                  {item.type === "checkbox" && (
                    <ToggleBtn
                      toggleState={commandParams?.[command.Name]?.[item.label]}
                      handleToggle={handleParameters}
                      field={item.label}
                    />
                  )}
                </div>
              );
            })}

          {props.elemtype === "tile" &&
            commandMappingTile?.[command.Name]?.map((item) => {
              return (
                <div
                  className={styles.labelintable}
                  style={
                    item.type === "checkbox"
                      ? { justifyContent: "flex-start", background: "#F8F8F8" }
                      : { background: "#F8F8F8" }
                  }
                >
                  {item.type !== "button" &&
                    (item.label !== "CaptchaControl" ||
                      (item.label === "CaptchaControl" &&
                        commandParams?.[command.Name]?.["CaptchaEnabled"] ===
                          "true")) && (
                      <div
                        style={{
                          margin: "0 0 5px",
                          font: "normal normal 100 12px/18px Open Sans",
                          color: "#202020",
                        }}
                      >
                        {" "}
                        {t(`${item.label}`)}
                        {item.label !== "CaptchaControl" &&
                          item.label !== "CaptchaEnabled" && (
                            <span style={{ color: "#C32525" }}>*</span>
                          )}{" "}
                      </div>
                    )}

                  {((item.type === "dropdown" &&
                    item.label !== "CaptchaControl") ||
                    (item.type === "dropdown" &&
                      item.label === "CaptchaControl" &&
                      commandParams?.[command.Name]?.["CaptchaEnabled"] ===
                        "true")) && (
                    <DropDownMenu
                      width={200}
                      options={item.value}
                      command={command?.["Parameters"]?.[item.label]}
                      handleCommand={handleParameters}
                      label={item.label}
                    ></DropDownMenu>
                  )}
                  {item.type === "checkbox" && (
                    <ToggleBtn
                      toggleState={commandParams?.[command.Name]?.[item.label]}
                      handleToggle={handleParameters}
                      field={item.label}
                    />
                  )}
                  {item.type === "button" && (
                    <>
                      <div></div>
                      <BlueButton
                        className="blue-button"
                        onClick={() =>
                          addToTileParameters(commandParams.RouteJourney)
                        }
                      >
                        {" "}
                        {t(`${item.label}`)}{" "}
                      </BlueButton>
                    </>
                  )}
                </div>
              );
            })}
        </div>

        {props.elemtype === "tile" && parametersTile_arr?.length > 0 && (
          <div className={classes.table}>
            <span
              style={{
                font: "normal normal 600 14px/19px Open Sans",
                margin: "10px",
              }}
            >
              Added Routes
            </span>

            <table style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Tile Name</th>
                  <th>Next Form Name</th>
                  <th>Decision Field</th>
                  <th></th>
                </tr>
              </thead>

              <tbody>
                {parametersTile_arr?.map((obj, count) => {
                  return (
                    <>
                      <tr>
                        <td>{count + 1}</td>
                        {Object.values(obj).map((item) => {
                          return <td>{item}</td>;
                        })}
                        <td
                          style={{ width: "40px" }}
                          onClick={() => {
                            deleteTileParameters(count);
                          }}
                        >
                          <img src={remove} alt="remove Item" />
                        </td>
                      </tr>
                    </>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default Command;
